<template>
<div class="OauthButtons">
  <button v-for="name in ['google', 'facebook', 'apple']"
    @click.prevent="click(name)"
    type="button"
    tabindex="-1">
    <icon-svg :symbol="`logo-${name}-color`"/>
  </button>
</div>
</template>

<style lang="scss">
.OauthButtons {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  & > button {
    font: inherit;
    cursor: pointer;
    box-sizing: border-box;
    border-radius: .25rem;
    border: 0;
    margin: 0;
    flex: 0 0 auto;
    background: none;
    width: 2em;
    height: 2em;
    padding: .25em;
    .icon {
      width: 100%;
      height: 100%;
      display: block;
    }
    &:hover {
      background-color: $accent-lighten;
    }
  }
}
</style>

<script>
export default {
  name: 'OauthButtons',
  methods: {
    async click(name) {
      console.log('OAuth', name);
    },
  },
}
</script>
